import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '../shared/layout.module';
import { AuthenticationService } from '../shared/services/authentication.service';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './login/login.component';
/* components */
import { PagesComponent } from './pages.component';
import { routing } from './pages.routing';
import {UserService} from '../shared/services/user.service';



@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        routing,
        BrowserModule,
        BrowserAnimationsModule,
    ],
    declarations: [
        PagesComponent,
        LoginComponent
    ],
    providers: [
      AuthenticationService,
      UserService
    ]
})
export class PagesModule { }
